const shadows = {
  level1: '0 4px 16px rgba(26, 26, 26, 0.1);',
  level2: '0 8px 24px rgba(26, 26, 26, 0.1);',
  level3: '0 16px 32px rgba(26, 26, 26, 0.1);',
  level4: '0 16px 48px rgba(26, 26, 26, 0.1);',
  cardSm: '0 1px 5px 0 rgba(0, 0, 0, 0.1);',
};

export default shadows;
